module.exports = __webpack_public_path__ + "img/thumbnail_LionTailedMacaque_f_normal.7ac57b33.png";